<template>
  <div class="period-selection-container">
    <div class="period-selection-container__section">
      <div
        v-for="(p, index) in getPeriods"
        :key="'period-selection' + index"
        class="period-selection-container__period"
        :class="[{ active: p.active && !p.completed }]"
        @click="onSelectPeriodHandler(p)"
      >
        <span class="d-block color-gray-7 font-14 font-weight-bold">
          {{ p.month }}
        </span>
        <span class="color-gray-7 font-14">
          {{ p.year }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/es-do';

const MONTH_FORMAT = 'MMM';
const YEAR_FORMAT = 'YYYY';
const INITIAL_SCHOLARSHIP_MONTH_INDEX = 6;

export default {
  name: 'NavigationPeriod',
  props: {
    currentPeriod: {
      type: Date,
      required: true,
    },
    initialPeriod: {
      type: Date,
      required: true,
    },
  },
  data: () => ({
    currentPeriodModel: null,
  }),
  computed: {
    getPeriods() {
      const initialPeriod = moment().set({
        year: this.initialPeriod.getFullYear(),
        month: INITIAL_SCHOLARSHIP_MONTH_INDEX,
      });
      const periods = [];
      for (let index = 1; index <= 12; index++) {
        const p = moment(initialPeriod).add(index, 'month');
        periods.push({
          date: p,
          month: p.format(MONTH_FORMAT).toUpperCase(),
          year: p.format(YEAR_FORMAT),
          active:
            this.formatDateToEval(
              moment(this.currentPeriodModel || this.currentPeriod)
            ) == this.formatDateToEval(p),
        });
      }
      return periods;
    },
  },
  watch: {
    currentPeriod() {
      this.currentPeriodModel = this.currentPeriod;
    },
  },
  methods: {
    formatDateToEval(value) {
      return moment(value).format(`${MONTH_FORMAT} ${YEAR_FORMAT}`);
    },
    onSelectPeriodHandler({ date }) {
      this.$emit('on-select-period', new Date(date));
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';

.period-selection-container {
  display: flex;
  justify-content: center;
  align-items: center;
  &__section {
    display: flex;
    flex-flow: row wrap;
    flex: 1;
  }
  &__period {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    span {
      user-select: none;
    }
    span:last-child {
      margin-top: -4px;
    }
    &.active {
      padding: 2px 0px;
      background: map-get($colors, 'orange');
      span {
        color: map-get($colors, 'white') !important;
      }
      border-radius: 20px;
    }
  }
}
.dot {
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border-style: solid;
  border-width: 1px;
  display: inline-block;
  margin-right: 15px;
  position: absolute;
  left: 15px;
  top: -25px;
}

.title-icon {
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 3px;
}

.dot.green {
  background-color: #2db782;
}
</style>
